module.exports = __webpack_public_path__ + "static/media/Bell_beaker_eba_wales_200px.fd7963e3.png";